// Editorial section label: "— ABOUT US" with leading dash (via CSS).
export const SectionLabel = ({ children, className = "" }) => (
  <span className={`section-label ${className}`}>{children}</span>
);
